import { EntityTag } from '../../Entity'
import { getTagActionSize, TAG_HEIGHT } from '../../Tag'

import { EntityExtraTagsItemStatuses } from './EntityExtraTagsItemStatuses'

function EntityExtraTagsItem({
  Icon,
  count,
  errorCount,
  height = TAG_HEIGHT.height28,
  newCount,
  text,
  ...restProps
}) {
  const hasStatuses = Boolean(newCount) || Boolean(errorCount)

  return (
    <EntityTag
      {...restProps}
      Icon={Icon}
      height={height}
      meta={
        hasStatuses ? (
          <EntityExtraTagsItemStatuses
            errorCount={errorCount}
            height={getTagActionSize(height)}
            newCount={newCount}
          />
        ) : null
      }
      name={count ? `${text} ${count}` : text}
    />
  )
}

export default EntityExtraTagsItem
